export const stripTrailingSlash = (stringToBeReplaced: string): string => {
  return stringToBeReplaced.endsWith('/')
    ? stringToBeReplaced.slice(0, -1)
    : stringToBeReplaced;
};
